export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00948.0efc6b37.png";